import "regenerator-runtime/runtime";
import axios from 'axios';

class CustomSearch {

    async CustomSearch(requestBody){

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.CUSTOM_SEARCH + "/BPCustomSearch_service.php"

        var arrResponse;

        await axios.post(APIurl,requestBody,null)
        .then(response => {
            arrResponse = JSON.parse(response.data);

            let i = 0;

            if(requestBody.arrCategories != undefined) {
                if(!requestBody.arrCategories && !requestBody.numMaxPrice && !requestBody.numMinPrice && !requestBody.arrCustomFieldQueries){
                    arrResponse.Records.forEach((item,index) => {
                        if(item.CustomFields.find(y => y.Code === process.env.CF_PART_NUMBER).Values[0] === requestBody.strKeyword){
                            let holdItem = arrResponse.Records[0];
                            arrResponse.Records[0] = item;
                            arrResponse.Records[index] = holdItem;
                        }
                    });
                }

                while (i < arrResponse.arrCategories.length) {
                    const element = arrResponse.arrCategories[i];
                    
                    let parentIndex = 0
                    
                    if(element.ParentCategoryID){
                        //                                              //Busca al padre del elemento actual
                        for (let j = 0; j < arrResponse.arrCategories.length; j++) {
                            const elementPadre = arrResponse.arrCategories[j];
                            if(elementPadre.ID === element.ParentCategoryID){
                                //                                      //una vez encontrado guarda el index
                                parentIndex = j;
                                break;
                            }
                        }
                        //                                              //revisa que no sea null
                        if(!arrResponse.arrCategories[parentIndex].ChildCategories){
                            arrResponse.arrCategories[parentIndex].ChildCategories = [];
                        }
                        //                                              //inserta el hijo en el array de hijos del padre
                        arrResponse.arrCategories[parentIndex].ChildCategories.push(element);
                        //                                              //elimina el hijo del array principal
                        arrResponse.arrCategories.splice(i, 1);
                    } else {
                        i++;
                    }
                }
            }
        })
        .catch(error => console.error(error));

        return arrResponse;
    }

    async SearchAndFilterItemAsArcadierAPI(requestBody){
        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.CUSTOM_SEARCH + "/SNPSearchNumberParts_service.php"
        var result;

        await axios.post(APIurl,requestBody,null)
        .then(response => {
            result = JSON.parse(response.data);
        })
        .catch(error => console.error(error));


        return result;
    }
}

module.exports = CustomSearch;